module.exports = __webpack_public_path__ + "static/img/round2.f0823075.jpg";